module.exports = __webpack_public_path__ + "static/img/return_good_example_1.033b0ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/return_good_example_1.jpg
// module id = SlLL
// module chunks = 1